/* ============================================================================
   ORIPAYA · SAKURA COLLECTORS CLUB — Fiche produit
   assets/oripaya-produit.js

   Script de sections/oripaya-produit.liquid.

   PRINCIPE DIRECTEUR — ce fichier n'est qu'une AMÉLIORATION. Sans lui, la
   fiche reste entièrement fonctionnelle :
     · le formulaire POSTe vers /cart/add et Shopify rend la page panier ;
     · le sélecteur de variantes est un <select name="id"> natif ;
     · les vignettes sont des liens d'ancre qui font défiler la piste ;
     · le sélecteur de quantité est un <input type="number">.
   Aucune fonction essentielle n'est déplacée ici.

   DÉPENDANCES : aucune. Pas de bibliothèque, pas de polyfill, pas de requête
   réseau au chargement. Le seul point de contact avec le thème Nexus est
   l'événement « cart-update » que son <cart-drawer> écoute déjà : on l'émet,
   on ne réécrit pas son tiroir.

   CE QU'ON NE FAIT PAS — on ne sérialise jamais les variantes. La table de
   correspondance « combinaison d'options → identifiant » est déjà dans le
   DOM sous la forme du <select> d'index, qui est un contrôle fonctionnel et
   non une charge utile morte. Les deux produits du catalogue à 196 et 120
   variantes ne coûtent donc pas un octet de JSON.
   ============================================================================ */

(function () {
  'use strict';

  /* ==========================================================================
     UTILITAIRES
     ========================================================================== */

  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function borner(valeur, minimum, maximum) {
    return Math.min(Math.max(valeur, minimum), maximum);
  }

  /* Association de formulaire par l'attribut form=.
     Quand on remplace le <form> d'achat par du balisage fraîchement rendu,
     les contrôles extérieurs qui le désignaient par son identifiant perdent
     leur propriétaire : le <select name="id"> ne serait alors plus posté, en
     silence. Réécrire l'attribut force le navigateur à réassocier. */
  function reassocierControles(racine) {
    racine.querySelectorAll('select[form], input[form]').forEach(function (controle) {
      var cible = controle.getAttribute('form');
      controle.removeAttribute('form');
      controle.setAttribute('form', cible);
    });
  }

  /* Remplace le contenu des régions marquées [data-oripaya-cible] par celui
     du document fraîchement rendu. On remplace l'intérieur, jamais l'élément
     lui-même : les références conservées par les autres composants restent
     valides. */
  function remplacerCibles(section, document_frais, exclues) {
    var focusAvant = document.activeElement && document.activeElement.id;
    var selectionAvant = null;
    if (document.activeElement && typeof document.activeElement.selectionStart === 'number') {
      selectionAvant = document.activeElement.selectionStart;
    }

    section.querySelectorAll('[data-oripaya-cible]').forEach(function (region) {
      var nom = region.getAttribute('data-oripaya-cible');
      if (exclues && exclues.indexOf(nom) !== -1) return;
      var fraiche = document_frais.querySelector('[data-oripaya-cible="' + nom + '"]');
      if (!fraiche) return;
      region.innerHTML = fraiche.innerHTML;
    });

    reassocierControles(section);

    // Le focus doit revenir sur le contrôle que l'on vient d'actionner :
    // sans cela, chaque changement d'option renvoie l'utilisateur clavier
    // en haut du document.
    if (focusAvant) {
      var repris = document.getElementById(focusAvant);
      if (repris) {
        repris.focus({ preventScroll: true });
        if (selectionAvant !== null && typeof repris.setSelectionRange === 'function') {
          try { repris.setSelectionRange(selectionAvant, selectionAvant); } catch (e) { /* champ non textuel */ }
        }
      }
    }
  }

  function analyser(texte) {
    return new DOMParser().parseFromString(texte, 'text/html');
  }

  /* ==========================================================================
     GALERIE MÉDIA
     ========================================================================== */

  class OripayaGalerie extends HTMLElement {
    connectedCallback() {
      this.scene = this.querySelector('[data-oripaya-scene]');
      if (!this.scene) return;

      this.vues = Array.prototype.slice.call(this.querySelectorAll('[data-oripaya-vue]'));
      this.vignettes = Array.prototype.slice.call(this.querySelectorAll('[data-oripaya-vignette]'));
      this.compteur = this.querySelector('[data-oripaya-compteur-index]');

      this._brancherVignettes();
      this._brancherClavier();
      this._observerDefilement();
      if (this.dataset.loupe === '1') this._brancherLoupe();
      this._ouvrirSurMediaInitial();
    }

    /* Une adresse du type /products/x?variant=123 doit ouvrir la galerie sur
       le média de CETTE variante, pas sur la première image du produit. Le
       saut est instantané : à l'arrivée sur la page, une animation de
       défilement ressemblerait à un bug. */
    _ouvrirSurMediaInitial() {
      var initial = this.getAttribute('data-media-initial');
      if (!initial || this.vues.length < 2) return;
      if (this.vues[0].getAttribute('data-media-id') === initial) return;
      for (var i = 0; i < this.vues.length; i++) {
        if (this.vues[i].getAttribute('data-media-id') === initial) {
          this._defilerVers(this.vues[i]);
          this._marquerActif(i);
          return;
        }
      }
    }

    disconnectedCallback() {
      if (this.observateur) this.observateur.disconnect();
    }

    /* --- Vignettes ---------------------------------------------------------
       Ce sont de vrais liens d'ancre : sans JavaScript, le navigateur fait
       déjà défiler la piste jusqu'à la cible. On intercepte uniquement pour
       ne pas empiler une entrée d'historique par vignette cliquée. */
    _brancherVignettes() {
      var self = this;
      this.vignettes.forEach(function (vignette) {
        vignette.addEventListener('click', function (evenement) {
          evenement.preventDefault();
          self.activerMedia(vignette.getAttribute('data-media-id'));
        });
      });
    }

    /* --- Clavier -----------------------------------------------------------
       La piste est un conteneur défilable focusable : les flèches doivent y
       déplacer d'une vue entière, pas de quelques pixels. */
    _brancherClavier() {
      if (this.vues.length < 2) return;
      var self = this;
      this.scene.addEventListener('keydown', function (evenement) {
        var pas = 0;
        if (evenement.key === 'ArrowRight') pas = 1;
        else if (evenement.key === 'ArrowLeft') pas = -1;
        else return;
        evenement.preventDefault();
        var suivant = borner(self._indexActif() + pas, 0, self.vues.length - 1);
        self._defilerVers(self.vues[suivant]);
        self._marquerActif(suivant);
      });
    }

    _indexActif() {
      var gauche = this.scene.scrollLeft;
      var meilleur = 0;
      var ecartMin = Infinity;
      for (var i = 0; i < this.vues.length; i++) {
        var ecart = Math.abs(this.vues[i].offsetLeft - this.vues[0].offsetLeft - gauche);
        if (ecart < ecartMin) { ecartMin = ecart; meilleur = i; }
      }
      return meilleur;
    }

    /* --- Synchronisation vignette ↔ défilement ---------------------------- */
    _observerDefilement() {
      if (this.vues.length < 2 || typeof IntersectionObserver === 'undefined') return;
      var self = this;
      this.observateur = new IntersectionObserver(
        function (entrees) {
          entrees.forEach(function (entree) {
            if (!entree.isIntersecting) return;
            self._marquerActif(self.vues.indexOf(entree.target));
          });
        },
        { root: this.scene, threshold: 0.6 }
      );
      this.vues.forEach(function (vue) { self.observateur.observe(vue); });
    }

    _marquerActif(index) {
      if (index < 0) return;
      this.vignettes.forEach(function (vignette, rang) {
        if (rang === index) vignette.setAttribute('aria-current', 'true');
        else vignette.removeAttribute('aria-current');
      });
      if (this.compteur) this.compteur.textContent = String(index + 1);
    }

    /* Le changement de visuel est INSTANTANÉ, et c'est un choix.
       Un défilement animé ferait passer l'oeil sur les visuels intermédiaires
       — sur une fiche à vingt photos, cliquer la vignette 12 déclencherait un
       défilé de onze images sans rapport. C'est aussi le comportement le plus
       robuste : `behavior: 'smooth'` est neutralisé par certains profils de
       navigateur et par les réglages système d'animation réduite, et un
       défilement annulé laisserait la galerie sur la mauvaise image.
       On affecte donc scrollLeft directement. */
    _defilerVers(vue) {
      if (!vue) return;
      // Position relative mesurée sur les rectangles : elle ne dépend pas de
      // l'élément de positionnement, contrairement à offsetLeft.
      var cadreScene = this.scene.getBoundingClientRect();
      var cadreVue = vue.getBoundingClientRect();
      this.scene.scrollLeft = this.scene.scrollLeft + (cadreVue.left - cadreScene.left);
    }

    /* API publique : appelée par le sélecteur de variantes quand la variante
       choisie porte son propre média. */
    activerMedia(identifiantMedia) {
      if (!identifiantMedia) return;
      for (var i = 0; i < this.vues.length; i++) {
        if (this.vues[i].getAttribute('data-media-id') === String(identifiantMedia)) {
          this._defilerVers(this.vues[i]);
          this._marquerActif(i);
          return;
        }
      }
    }

    /* --- La loupe ----------------------------------------------------------
       transform: scale() sur l'image dans un cadre déjà en overflow hidden.
       Aucune bibliothèque, aucune seconde image, aucune propriété de mise en
       page animée. Réservée au pointeur fin : au doigt, un survol n'existe
       pas, et le geste attendu est le défilement de la piste. */
    _brancherLoupe() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      Array.prototype.forEach.call(this.querySelectorAll('[data-oripaya-loupe]'), function (cadre) {
        var image = cadre.querySelector('.oripaya-galerie__img');
        if (!image) return;

        var suivre = function (evenement) {
          if (evenement.pointerType && evenement.pointerType !== 'mouse') return;
          var rect = cadre.getBoundingClientRect();
          var x = borner(((evenement.clientX - rect.left) / rect.width) * 100, 0, 100);
          var y = borner(((evenement.clientY - rect.top) / rect.height) * 100, 0, 100);
          cadre.style.setProperty('--oripaya-ox', x.toFixed(2) + '%');
          cadre.style.setProperty('--oripaya-oy', y.toFixed(2) + '%');
        };

        cadre.addEventListener('pointerenter', function (evenement) {
          if (evenement.pointerType && evenement.pointerType !== 'mouse') return;
          suivre(evenement);
          cadre.classList.add('est-zoome');
        });
        cadre.addEventListener('pointermove', suivre);
        cadre.addEventListener('pointerleave', function () {
          cadre.classList.remove('est-zoome');
        });
      });
    }
  }

  /* ==========================================================================
     SÉLECTEUR DE VARIANTES — régime « liste longue »
     Les deux produits à 196 et 120 variantes. Le <select name="id"> natif est
     le contrôle réel : il fonctionne sans une ligne de script. On lui ajoute
     un champ de recherche qui filtre ses entrées, en retirant et réinsérant
     de vraies balises <option> — masquer une <option> par CSS n'est pas
     fiable d'un navigateur à l'autre.
     ========================================================================== */

  class OripayaListeVariantes extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-oripaya-select-variante]');
      if (!this.select) return;

      this.section = this.closest('[data-oripaya-fiche]');
      // Copie de travail des options telles que le serveur les a rendues.
      this.optionsSource = Array.prototype.slice.call(this.select.options);

      if (this.dataset.recherche === '1' && this.optionsSource.length > 6) {
        this._construireRecherche();
      }

      var self = this;
      this.select.addEventListener('change', function () {
        self._surChangement();
      });
    }

    _construireRecherche() {
      var libelle = this.dataset.libelleRecherche || '';
      var enveloppe = document.createElement('div');
      enveloppe.className = 'oripaya-variantes__recherche';

      var identifiant = this.select.id + '-recherche';
      var etiquette = document.createElement('label');
      etiquette.className = 'sk-label';
      etiquette.setAttribute('for', identifiant);
      etiquette.textContent = libelle;

      var champ = document.createElement('input');
      champ.className = 'sk-champ';
      champ.type = 'search';
      champ.id = identifiant;
      champ.autocomplete = 'off';
      champ.placeholder = this.dataset.placeholder || '';

      var compte = document.createElement('p');
      compte.className = 'oripaya-variantes__compte';
      compte.setAttribute('aria-live', 'polite');
      compte.setAttribute('role', 'status');

      // Sans libellé fourni par le marchand, on n'invente pas de texte : le
      // champ prend alors le nom accessible du select lui-même.
      if (!libelle) {
        etiquette.className = 'sk-visuellement-cache';
        etiquette.textContent = this.select.previousElementSibling
          ? this.select.previousElementSibling.textContent.trim()
          : '';
      }

      enveloppe.appendChild(etiquette);
      enveloppe.appendChild(champ);
      enveloppe.appendChild(compte);
      this.insertBefore(enveloppe, this.firstChild);

      var self = this;
      this.compteResultats = compte;
      champ.addEventListener('input', function () {
        self._filtrer(champ.value);
      });
    }

    _filtrer(requete) {
      var terme = requete.trim().toLowerCase();
      var valeurCourante = this.select.value;
      var retenues = this.optionsSource.filter(function (option) {
        return !terme || option.textContent.toLowerCase().indexOf(terme) !== -1;
      });

      // La variante actuellement sélectionnée reste toujours dans la liste :
      // un filtre ne doit jamais changer ce qui sera posté.
      var presente = retenues.some(function (option) { return option.value === valeurCourante; });
      if (!presente) {
        var courante = this.optionsSource.filter(function (option) { return option.value === valeurCourante; });
        retenues = courante.concat(retenues);
      }

      this.select.textContent = '';
      var fragment = document.createDocumentFragment();
      retenues.forEach(function (option) { fragment.appendChild(option); });
      this.select.appendChild(fragment);
      this.select.value = valeurCourante;

      if (this.compteResultats) {
        var libelle = this.dataset.libelleResultats || '';
        this.compteResultats.textContent = libelle ? retenues.length + ' ' + libelle : '';
      }
    }

    _surChangement() {
      var choisie = this.select.options[this.select.selectedIndex];
      if (!choisie || !this.section) return;

      // Le média de la variante, s'il existe.
      var galerie = this.section.querySelector('oripaya-galerie');
      if (galerie && typeof galerie.activerMedia === 'function') {
        galerie.activerMedia(choisie.getAttribute('data-media-id'));
      }

      // Prix, stock, précommande et CTA sont rafraîchis par le serveur. On
      // exclut la région « variantes » : la reconstruire détruirait le champ
      // de recherche et la position du curseur.
      rafraichirVariante(this.section, choisie.value, ['variantes']);
    }
  }

  /* ==========================================================================
     SÉLECTEUR DE VARIANTES — régime « options »
     Radios dans un fieldset légendé. La combinaison choisie est résolue en
     identifiant de variante grâce à l'index déjà présent dans le DOM, PUIS
     confirmée par un rendu serveur. Cet ordre est délibéré : si le réseau
     échoue, le formulaire poste déjà la bonne variante.
     ========================================================================== */

  class OripayaOptions extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-oripaya-fiche]');
      this.index = this.querySelector('[data-oripaya-index-variantes]');
      var self = this;

      this.addEventListener('change', function (evenement) {
        if (!evenement.target.matches('.oripaya-variantes__radio')) return;
        self._surChangement();
      });
    }

    _valeursChoisies() {
      return Array.prototype.slice
        .call(this.querySelectorAll('.oripaya-variantes__radio:checked'))
        .sort(function (a, b) {
          return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
        });
    }

    _surChangement() {
      var choisies = this._valeursChoisies();
      if (!choisies.length) return;

      // 1. Reflet immédiat dans les légendes.
      Array.prototype.forEach.call(this.querySelectorAll('.oripaya-variantes__groupe'), function (groupe) {
        var coche = groupe.querySelector('.oripaya-variantes__radio:checked');
        var affichage = groupe.querySelector('[data-oripaya-valeur-choisie]');
        if (coche && affichage) affichage.textContent = coche.value;
      });

      // 2. Résolution locale de l'identifiant de variante, via l'index.
      var titre = choisies.map(function (radio) { return radio.value; }).join(' / ');
      var identifiant = null;
      if (this.index) {
        for (var i = 0; i < this.index.options.length; i++) {
          if (this.index.options[i].getAttribute('data-titre') === titre) {
            this.index.selectedIndex = i;
            identifiant = this.index.options[i].value;
            var media = this.index.options[i].getAttribute('data-media-id');
            var galerie = this.section && this.section.querySelector('oripaya-galerie');
            if (galerie && typeof galerie.activerMedia === 'function') galerie.activerMedia(media);
            break;
          }
        }
      }

      // 3. Confirmation serveur : prix, stock, disponibilité, état des
      //    pastilles. On passe par option_values plutôt que par un
      //    identifiant, ce qui permet à Shopify de résoudre lui-même les
      //    combinaisons indisponibles.
      if (!this.section) return;
      var valeurs = choisies
        .map(function (radio) { return radio.dataset.optionValueId; })
        .filter(Boolean);
      if (!valeurs.length) return;

      var url =
        this.dataset.url +
        '?option_values=' + encodeURIComponent(valeurs.join(',')) +
        '&section_id=' + encodeURIComponent(this.dataset.sectionId);

      appliquerRendu(this.section, url, [], identifiant);
    }
  }

  /* ==========================================================================
     RENDU DE SECTION — mutualisé par les deux régimes
     ========================================================================== */

  function rafraichirVariante(section, identifiantVariante, exclues) {
    var url =
      section.getAttribute('data-product-url') +
      '?variant=' + encodeURIComponent(identifiantVariante) +
      '&section_id=' + encodeURIComponent(section.getAttribute('data-section-id'));
    appliquerRendu(section, url, exclues, identifiantVariante);
  }

  function appliquerRendu(section, url, exclues, identifiantVariante) {
    section.setAttribute('aria-busy', 'true');

    fetch(url)
      .then(function (reponse) {
        if (!reponse.ok) throw new Error('rendu de section indisponible');
        return reponse.text();
      })
      .then(function (texte) {
        var frais = analyser(texte);
        remplacerCibles(section, frais, exclues);

        // L'adresse suit la variante : un lien partagé rouvre la bonne.
        var champ = section.querySelector('[data-oripaya-champ-variante]');
        var identifiant = identifiantVariante;
        if (!identifiant && champ) identifiant = champ.value;
        if (identifiant && window.history && window.history.replaceState) {
          var adresse = new URL(window.location.href);
          adresse.searchParams.set('variant', identifiant);
          window.history.replaceState({}, '', adresse.toString());
        }
      })
      .catch(function () {
        // Silence volontaire : la variante correcte est déjà sélectionnée
        // dans le contrôle qui porte name="id". Le seul effet d'un échec
        // réseau est un prix affiché en retard, jamais un mauvais ajout.
      })
      .finally(function () {
        section.removeAttribute('aria-busy');
      });
  }

  /* ==========================================================================
     QUANTITÉ
     ========================================================================== */

  class OripayaQuantite extends HTMLElement {
    connectedCallback() {
      this.champ = this.querySelector('.oripaya-quantite__input');
      if (!this.champ) return;
      var self = this;

      Array.prototype.forEach.call(this.querySelectorAll('[data-oripaya-qte]'), function (bouton) {
        bouton.addEventListener('click', function () {
          self._ajuster(Number(bouton.getAttribute('data-oripaya-qte')));
        });
      });

      this.champ.addEventListener('change', function () { self._normaliser(); });
      this._majEtats();
    }

    _bornes() {
      var pas = Number(this.champ.step) || 1;
      var minimum = this.champ.min === '' ? 1 : Number(this.champ.min);
      var maximum = this.champ.max === '' ? Infinity : Number(this.champ.max);
      return { pas: pas, minimum: minimum, maximum: maximum };
    }

    _ajuster(sens) {
      var b = this._bornes();
      var valeur = Number(this.champ.value) || b.minimum;
      this.champ.value = borner(valeur + sens * b.pas, b.minimum, b.maximum);
      this._majEtats();
      this.champ.dispatchEvent(new Event('change', { bubbles: true }));
    }

    _normaliser() {
      var b = this._bornes();
      var valeur = Number(this.champ.value);
      if (!valeur || valeur < b.minimum) valeur = b.minimum;
      this.champ.value = borner(valeur, b.minimum, b.maximum);
      this._majEtats();
    }

    /* Un bouton qui ne peut plus rien faire doit le dire : disabled, et non
       simplement inopérant. */
    _majEtats() {
      var b = this._bornes();
      var valeur = Number(this.champ.value) || b.minimum;
      var moins = this.querySelector('[data-oripaya-qte="-1"]');
      var plus = this.querySelector('[data-oripaya-qte="1"]');
      if (moins) moins.disabled = valeur <= b.minimum;
      if (plus) plus.disabled = valeur >= b.maximum;
    }
  }

  /* ==========================================================================
     AJOUT AU PANIER
     ========================================================================== */

  class OripayaAchat extends HTMLElement {
    connectedCallback() {
      this.formulaire = this.querySelector('form');
      this.cta = this.querySelector('[data-oripaya-cta]');
      this.loader = this.querySelector('[data-oripaya-loader]');
      this.erreur = this.querySelector('[data-oripaya-erreur]');
      this.erreurTexte = this.querySelector('[data-oripaya-erreur-texte]');
      this.succes = this.querySelector('[data-oripaya-succes]');
      this.succesTexte = this.querySelector('[data-oripaya-succes-texte]');
      if (!this.formulaire || !this.cta) return;

      var self = this;
      this.formulaire.addEventListener('submit', function (evenement) {
        evenement.preventDefault();
        self._envoyer();
      });
    }

    _occupe(etat) {
      this.cta.setAttribute('aria-busy', etat ? 'true' : 'false');
      this.cta.disabled = etat;
      if (this.loader) this.loader.hidden = !etat;
    }

    _message(element, texte, elementTexte) {
      if (!element) return;
      if (!texte) { element.hidden = true; return; }
      if (elementTexte) elementTexte.textContent = texte;
      element.hidden = false;
    }

    _envoyer() {
      if (this.cta.getAttribute('aria-busy') === 'true') return;

      var self = this;
      // FormData ramasse aussi les contrôles rattachés par l'attribut form=,
      // donc le <select name="id"> du sélecteur de variantes.
      var donnees = new FormData(this.formulaire);
      donnees.append('sections', 'cart-drawer,cart-count,cart-main');

      this._message(this.erreur, null);
      this._message(this.succes, null);
      this._occupe(true);

      fetch(RACINE + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: donnees
      })
        .then(function (reponse) {
          return reponse.json().then(function (donneesReponse) {
            return { ok: reponse.ok, corps: donneesReponse };
          });
        })
        .then(function (resultat) {
          if (!resultat.ok) {
            // Shopify renvoie un message explicite (limite de quantité,
            // variante épuisée) : on l'affiche tel quel plutôt qu'un générique.
            var corps = resultat.corps || {};
            var message = corps.description || corps.message || self.dataset.texteErreur || '';
            self._message(self.erreur, message, self.erreurTexte);
            return;
          }

          self._message(self.succes, self.dataset.texteConfirmation || '', self.succesTexte);
          self._notifierPanier(resultat.corps);
        })
        .catch(function () {
          self._message(self.erreur, self.dataset.texteErreur || '', self.erreurTexte);
        })
        .finally(function () {
          self._occupe(false);
        });
    }

    /* On n'écrit pas un second tiroir de panier : le thème en a déjà un, qui
       écoute « cart-update ». On lui transmet les sections rendues par
       Shopify et le bouton d'origine, dont il se sert pour rendre le focus. */
    _notifierPanier(corps) {
      var tiroir = document.querySelector('cart-drawer');
      if (!tiroir) return;

      var sections = corps && corps.sections;
      var envoyer = function (donneesSections) {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections: donneesSections, button: this.cta },
            bubbles: true
          })
        );
      }.bind(this);

      if (sections) { envoyer(sections); return; }

      // Repli si l'API n'a pas renvoyé les sections demandées.
      fetch(RACINE + '?sections=cart-drawer,cart-count,cart-main')
        .then(function (reponse) { return reponse.json(); })
        .then(envoyer)
        .catch(function () { /* le message de confirmation reste affiché */ });
    }
  }

  /* ==========================================================================
     PRODUITS ASSOCIÉS
     Chargés au dernier moment, plafonnés à 4, rendus avec la carte signature.
     La section reste masquée tant qu'elle n'a rien à montrer, et se retire
     du document si Shopify ne recommande rien : une alcôve vide sous une
     fiche produit n'est pas un état, c'est un oubli.
     ========================================================================== */

  class OripayaRecommandations extends HTMLElement {
    connectedCallback() {
      this.contenu = this.querySelector('[data-oripaya-reco-contenu]');
      if (!this.contenu) return;

      var self = this;
      if (typeof IntersectionObserver === 'undefined') {
        this._charger();
        return;
      }
      this.observateur = new IntersectionObserver(
        function (entrees) {
          if (!entrees[0].isIntersecting) return;
          self.observateur.disconnect();
          self._charger();
        },
        { rootMargin: '400px 0px' }
      );
      this.observateur.observe(this);
    }

    _squelettes() {
      var nombre = Number(this.dataset.limite) || 4;
      var liste = document.createElement('ul');
      liste.className = 'oripaya-reco__squelettes';
      for (var i = 0; i < nombre; i++) {
        var element = document.createElement('li');
        element.className = 'sk-squelette-fiche';
        element.innerHTML =
          '<span class="sk-squelette sk-squelette--media"></span>' +
          '<span class="sk-squelette sk-squelette--texte-court"></span>' +
          '<span class="sk-squelette sk-squelette--titre"></span>' +
          '<span class="sk-squelette sk-squelette--prix"></span>';
        liste.appendChild(element);
      }
      this.contenu.appendChild(liste);
    }

    _charger() {
      var self = this;
      var url =
        this.dataset.url +
        '?section_id=' + encodeURIComponent(this.dataset.sectionId) +
        '&product_id=' + encodeURIComponent(this.dataset.productId) +
        '&limit=' + encodeURIComponent(this.dataset.limite || '4') +
        '&intent=' + encodeURIComponent(this.dataset.intention || 'related');

      this.hidden = false;
      this.setAttribute('aria-busy', 'true');
      this._squelettes();

      fetch(url)
        .then(function (reponse) {
          if (!reponse.ok) throw new Error('recommandations indisponibles');
          return reponse.text();
        })
        .then(function (texte) {
          var frais = analyser(texte).querySelector('[data-oripaya-reco-contenu]');
          if (!frais || !frais.querySelector('li')) { self.remove(); return; }
          self.contenu.innerHTML = frais.innerHTML;
          self.removeAttribute('aria-busy');
        })
        .catch(function () {
          self.remove();
        });
    }
  }

  /* ==========================================================================
     ENREGISTREMENT
     ========================================================================== */

  function definir(nom, classe) {
    if (!customElements.get(nom)) customElements.define(nom, classe);
  }

  definir('oripaya-galerie', OripayaGalerie);
  definir('oripaya-liste-variantes', OripayaListeVariantes);
  definir('oripaya-options', OripayaOptions);
  definir('oripaya-quantite', OripayaQuantite);
  definir('oripaya-achat', OripayaAchat);
  definir('oripaya-recommandations', OripayaRecommandations);
})();
